// frontend/src/utils/dailyMirror.js
import { DAILY_MIRROR_STORAGE_KEYS } from "../content/dailyMirror";

export function todayISO() {
  // YYYY-MM-DD
  return new Date().toISOString().slice(0, 10);
}

export function getOrInitStartDateISO() {
  const key = DAILY_MIRROR_STORAGE_KEYS.startDate;
  const existing = localStorage.getItem(key);
  if (existing) return existing;

  const t = todayISO();
  localStorage.setItem(key, t);
  return t;
}

export function daysBetweenISO(startISO, endISO) {
  // Treat both as local midnight to avoid timezone drift.
  const [sy, sm, sd] = startISO.split("-").map(Number);
  const [ey, em, ed] = endISO.split("-").map(Number);

  const a = new Date(sy, sm - 1, sd);
  const b = new Date(ey, em - 1, ed);

  const ms = b.getTime() - a.getTime();
  return Math.floor(ms / (1000 * 60 * 60 * 24));
}

export function getCompletedDates() {
  try {
    const raw = localStorage.getItem(DAILY_MIRROR_STORAGE_KEYS.completedDates);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function isCompletedToday() {
  const completed = getCompletedDates();
  return completed.includes(todayISO());
}

export function markCompletedToday() {
  const t = todayISO();
  const completed = getCompletedDates();
  if (completed.includes(t)) return;

  const next = [t, ...completed].slice(0, 240); // bounded history
  localStorage.setItem(
    DAILY_MIRROR_STORAGE_KEYS.completedDates,
    JSON.stringify(next)
  );
}
